<template>
  <div class="auth-form-container" style="margin-top: 10px;margin-left: 30px;">
    <el-card class="auth-form-card" shadow="hover" style="width: 190%;">
      <!--  企业认证修改表单 -->

      <el-form :model="boardForm" :rules="rules" ref="boardForm" label-width="500px" :validate-on-rule-change="true">
        <!-- 营业执照上传 -->
        <el-form-item label-width="0" style="text-align: left;">
          <div style="display: flex; align-items: flex-start;">
            <div style="display: flex; flex-direction: column; margin-right: 20px;">
              <span style="font-weight: bold;">上传营业执照自动读取内容</span>
              <span style="color: #999; font-size: 15px; margin-top: 5px;">
                请上传盖过公章的营业
              </span>
              <span style="color: #999; font-size: 15px; margin-top: 5px;">
                执照。仅支持png、jpg、pdf
              </span>
              <span style="color: #999; font-size: 15px; margin-top: 5px;">
                格式，其中pdf格式不支持内
              </span>
              <span style="color: #999; font-size: 15px; margin-top: 5px;">
                容识别
              </span>
            </div>
            <el-upload class="upload-area"
              :http-request="(file) => upload_images({ ...file, action: 'businessLicense' })" accept=".jpg,.png,.pdf"
              :show-file-list="false" :before-upload="beforeFileUpload">
              <div v-if="!boardForm.businessLicense" class="upload-placeholder"
                style="width: 300px; height: 200px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <i class="el-icon-plus upload-icon" style="font-size: 28px;"></i>
                <div>点击上传营业执照</div>
              </div>
              <img v-else :src="boardForm.businessLicense" style="width: 300px; height: 200px; object-fit: contain;" />
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="企业Id" label-width="160px" v-show="false">
          <el-input class="form-item" v-model="boardForm.companyId" placeholder="请输入企业Id..." clearable></el-input>
        </el-form-item>

        <el-form-item label="用戶Id" label-width="160px" v-show="false">
          <el-input class="form-item" v-model="boardForm.userId" placeholder="请输入用戶Id..." clearable></el-input>
        </el-form-item>

        <el-form-item label="企业名称" label-width="160px" prop="companyName" required>
          <el-input class="form-item" v-model="boardForm.companyName" placeholder="请输入企业全称"></el-input>
        </el-form-item>


        <el-form-item label="统一社会信用代码" label-width="160px"  class="upload-placeholder">
          <div>{{ boardForm.socialCreditCode }}</div>
        </el-form-item>


        <el-form-item label="公司类型" label-width="160px" prop="companyType" required>
          <el-select class="form-item" v-model.number="boardForm.companyType" clearable placeholder="请选择">
            <el-option v-for="item in allCompanyType" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="注册资金" label-width="160px" prop="registeredCapital" required>
          <el-input class="form-item" v-model="boardForm.registeredCapital" placeholder="请输入注册资金..."
            clearable></el-input>
        </el-form-item>

        <el-form-item label="注册地址" label-width="160px" prop="registeredAddress" required>
          <el-input class="form-item" v-model="boardForm.registeredAddress" placeholder="请输入注册地址..."
            clearable></el-input>
        </el-form-item>

        <el-form-item label="法人代表" label-width="160px" prop="legalPerson" required>
          <el-input class="form-item" v-model="boardForm.legalPerson" placeholder="请输入法人代表..." clearable></el-input>
        </el-form-item>

        <el-form-item label="成立日期" label-width="160px" prop="setUpTime" required>
          <el-date-picker class="form-item" type="date" placeholder="选择日期" v-model="boardForm.setUpTime"
            clearable></el-date-picker>
        </el-form-item>

        <el-form-item label="经营期限" label-width="160px" prop="operatingPeriod" required>
          <el-input class="form-item" v-model="boardForm.operatingPeriod" placeholder="例: xxxx年xx月xx日 至 xxxx年xx月xx日"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="经营范围" prop="businessNature" label-width="160px" required>
          <el-input class="form-item" type="textarea" rows="3" v-model="boardForm.businessNature"
            placeholder="请输入经营范围..." clearable></el-input>
        </el-form-item>

        <el-form-item label="开户行" label-width="160px" prop="accountBankName" required>
          <el-input class="form-item" v-model="boardForm.accountBankName" placeholder="请输入开户行..." clearable></el-input>
        </el-form-item>

        <el-form-item label="对公账户名称" label-width="160px" prop="accountName" required>
          <el-input class="form-item" v-model="boardForm.accountName" placeholder="请输入对公账户名称..." clearable></el-input>
        </el-form-item>

        <el-form-item label="对公账户" label-width="160px" prop="accountCode" required>
          <el-input class="form-item" v-model="boardForm.accountCode" placeholder="请输入对公账户..." clearable></el-input>
        </el-form-item>

        <el-form-item label="联系人姓名" label-width="160px" prop="contactsName" required>
          <el-input class="form-item" v-model="boardForm.contactsName" placeholder="请输入联系人姓名..." clearable></el-input>
        </el-form-item>

        <el-form-item label="联系人电话" label-width="160px" prop="contactsPhone" required>
          <el-input class="form-item" v-model="boardForm.contactsPhone" placeholder="请输入联系人电话..." clearable></el-input>
        </el-form-item>

        <el-form-item label="联系人邮箱" label-width="160px" prop="contactsEmail" required>
          <el-input class="form-item" v-model="boardForm.contactsEmail" placeholder="请输入联系人邮箱..." clearable></el-input>
        </el-form-item>

        <el-form-item label="经办人是否为法人" label-width="160px" prop="isLegalPerson" required>
          <el-radio-group v-model="boardForm.isLegalPerson">
            <el-radio label="是" value="是"></el-radio>
            <el-radio label="否" value="否"></el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="法人身份证照片" label-width="160px" required>
          <div class="container" style="display: flex; justify-content: flex-start;">
            <div style="margin-right: 40px;">
              <el-form-item prop="legalPersonIdCardFront" label-width="10px">
                <div class="upload-section">
                  <el-upload class="upload-area"
                    :http-request="(file) => upload_images({ ...file, action: 'legalPersonIdCardFront' })"
                    accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                    <div v-if="!boardForm.legalPersonIdCardFront" class="upload-placeholder"
                      style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                      <i class="el-icon-plus upload-icon" style="font-size: 28px;"></i>
                      <div>点击上传身份证正面</div>
                    </div>
                    <img v-else :src="boardForm.legalPersonIdCardFront"
                      style="width: 178px; height: 178px; object-fit: contain;" />
                  </el-upload>

                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="legalPersonIdCardBack" label-width="80px">
                <div class="upload-section">
                  <el-upload class="upload-area"
                    :http-request="(file) => upload_images({ ...file, action: 'legalPersonIdCardBack' })"
                    accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                    <div v-if="!boardForm.legalPersonIdCardBack" class="upload-placeholder"
                      style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                      <i class=" el-icon-plus upload-icon" style="font-size: 28px;"></i>
                      <div>点击上传身份证背面</div>
                    </div>
                    <img v-else :src="boardForm.legalPersonIdCardBack"
                      style="width: 178px; height: 178px; object-fit: contain;" />
                  </el-upload>

                </div>
              </el-form-item>
            </div>
          </div>
        </el-form-item>


        <div v-if="boardForm.isLegalPerson === '否'" style="margin-top: 20px;">


          <el-form-item label="经办人身份证照片" label-width="160px" required>
            <div class="container" style="display: flex; justify-content: flex-start;">
              <div style="margin-right: 40px;">
                <el-form-item prop="agentIdCardFront" label-width="10px">
                  <div class="upload-section">
                    <el-upload class="upload-area"
                      :http-request="(file) => upload_images({ ...file, action: 'agentIdCardFront' })"
                      accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                      <div v-if="!boardForm.agentIdCardFront" class="upload-placeholder"
                        style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                        <i class=" el-icon-plus upload-icon" style="font-size: 28px;"></i>
                        <div>点击上传经办人身份证正面</div>
                      </div>
                      <img v-else :src="boardForm.agentIdCardFront"
                        style="width: 178px; height: 178px; object-fit: contain;" />
                    </el-upload>

                  </div>
                </el-form-item>
              </div>
              <div>
                <el-form-item prop="agentIdCardBack" label-width="80px">
                  <div class="upload-section">
                    <el-upload class="upload-area"
                      :http-request="(file) => upload_images({ ...file, action: 'agentIdCardBack' })" accept=".jpg,.png"
                      :show-file-list="false" :before-upload="beforeFileUpload">
                      <div v-if="!boardForm.agentIdCardBack" class="upload-placeholder"
                        style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                        <i class=" el-icon-plus upload-icon" style="font-size: 28px;"></i>
                        <div>点击上传经办人身份证背面</div>
                      </div>
                      <img v-else :src="boardForm.agentIdCardBack"
                        style="width: 178px; height: 178px; object-fit: contain;" />
                    </el-upload>

                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form-item>

          <div>



            <el-row :gutter="20">

              <el-col :span="3.5">


                <div class="upload-header1">
                  <span class="required-mark">*</span>
                  <span>请上传企业身份审核授权书</span>

                </div>


                <div class="download-links">
                  <span class="download-link" @click="downloadFile('AuthorizationLetter.docx')">企业身份审核授权书模板下载</span>
                </div>








              </el-col>


              <el-col :span="5">

                <el-form-item label-width="10px" required>
                  <el-upload class="upload-area"
                    :http-request="(file) => upload_file({ ...file, action: 'authorizationLetter' })"
                    accept=".docx,.doc" :show-file-list="false">
                    <div v-if="!boardForm.authorizationLetter" class="upload-placeholder"
                      style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f5f7fa;">
                      <i class="el-icon-plus upload-icon" style="font-size: 28px;"></i>
                      <div>点击上传授权书</div>
                    </div>
                    <div v-else
                      style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f0f9eb;">
                      <i class="el-icon-success upload-icon" style="font-size: 28px; color: #67c23a;"></i>
                      <div style="margin-top: 10px; color: #67c23a;">授权书已上传</div>
                    </div>
                  </el-upload>
                </el-form-item>





              </el-col>




            </el-row>






          </div>



        </div>




        <el-form-item label-width="0" style="margin-left: 0; text-align: left;">
          <div style="display: flex; align-items: center;">
            <el-checkbox v-model="boardForm.declarationChecked" style="margin-right: 10px;"></el-checkbox>
            <span style="color: #000;">
              我单位财务和经营状况良好，近三年没有发生重大数据安全事故没有因违法经营受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大
            </span>
          </div>
          <div style="padding-left: 25px; margin-top: 5px; color: #000;">
            数额罚款等行政处罚，若在数据交易过程中发现我单位近三年内在经营活动中有重大违法记录，我单位将承担因此引起的一切后果，特此声明!
          </div>
          <div style="margin-top: 20px;">
            <el-button type="primary" @click="submitForm" :disabled="!boardForm.declarationChecked">提交审核</el-button>
            <el-button @click="resetForm">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'boardForm',
  data() {
    return {
      boardForm: {
        id: "",
        typeName: "",
        title: "",
        published: true,
        content: "",
        companyId: "",
        userId: "",
        companyName: "",
        socialCreditCode: "",
        noSocialCreditCode: false,
        companyType: "",
        registeredCapital: "",

        legalPerson: "",
        setUpTime: "",
        //operatingPeriod: "2008-01-01 至 2028-01-01",

        accountBankName: "",
        accountName: "",
        accountCode: "",

        contactsName: "",
        contactsPhone: "",
        contactsEmail: "",

        registeredAddress: "",
        businessNature: "",
        isLegalPerson: "是",

        picture: "",
        avatar: "",
        companyLogo: "",

        legalPersonIdCardFront: "",
        legalPersonIdCardBack: "",
        agentIdCardFront: "",
        agentIdCardBack: "",
        declarationChecked: false,
        businessLicense: "",
        authorizationLetter: "",

      },

      allCompanyType: [
        {
          value: "全民所有制企业",
          name: "全民所有制企业",
        },
        {
          value: "有限责任公司",
          name: "有限责任公司",
        },
        {
          value: "股份有限公司",
          name: "股份有限公司",
        },
        {
          value: "集体所有制",
          name: "集体所有制",
        },
        {
          value: "合伙企业",
          name: "合伙企业",
        },
        {
          value: "其他有限责任公司分公司",
          name: "其他有限责任公司分公司",
        },
        {
          value: "其他",
          name: "其他",
        },
      ],

      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        socialCreditCode: [
          {
            validator: (rule, value, callback) => {
              if (!this.boardForm.noSocialCreditCode && !value) {
                callback(new Error('请输入统一社会信用代码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        companyType: [
          { required: true, message: '请选择公司类型', trigger: 'change' }
        ],
        registeredCapital: [
          { required: true, message: '请输入注册资金', trigger: 'blur' }
        ],
        registeredAddress: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        setUpTime: [
          { required: true, message: '请选择成立日期', trigger: 'change' }
        ],
        operatingPeriod: [
          { required: true, message: '请输入经营期限', trigger: 'blur' }
        ],
        businessNature: [
          { required: true, message: '请输入经营范围', trigger: 'blur' }
        ],
        accountBankName: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入对公账户名称', trigger: 'blur' }
        ],
        accountCode: [
          { required: true, message: '请输入对公账户', trigger: 'blur' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' }
        ],
        contactsEmail: [
          { required: true, message: '请输入联系人邮箱', trigger: 'blur' },
        ],
        isLegalPerson: [
          { required: true, message: '请选择经办人是否为法人', trigger: 'change' }
        ]
      }
    }
  },

  mounted() {
    this.initDetailInfo();
    this.getBusinessLicense();
    this.getLegalPersonIdCardFront();
    this.getLegalPersonIdCardBack();

  },
  methods: {
    handleLicenseSuccess(response, file) {
      this.boardForm.businessLicense = response.data.object.imageUrl;
      // 这里可以添加自动识别营业执照内容的逻辑
      // 例如调用OCR接口识别后自动填充表单
    },
    beforeLicenseUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isPDF = file.type === 'application/pdf';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG && !isPDF) {
        this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return false;
      }
      return true;
    },

    getBusinessLicense() {
      this.axios.get('/web/images/get?type=businessLicense', {
        responseType: 'blob'
      }).then(response => {
        const imageUrl = URL.createObjectURL(response.data);
        this.boardForm.businessLicense = imageUrl;
      }).catch(error => {
        console.error('获取营业执照失败:', error);
        this.$message.error('获取营业执照失败');
      });
    },

    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },

    getLegalPersonIdCardFront() {
      this.axios.get('/web/images/get?type=legalPersonIdCardFront', {
        responseType: 'blob'
      }).then(response => {
        const imageUrl = URL.createObjectURL(response.data);
        this.boardForm.legalPersonIdCardFront = imageUrl;
      }).catch(error => {
        console.error('获取法人身份证失败:', error);
        this.$message.error('获取法人身份证失败');
      });
    },


    getLegalPersonIdCardBack() {
      this.axios.get('/web/images/get?type=legalPersonIdCardBack', {
        responseType: 'blob'
      }).then(response => {
        const imageUrl = URL.createObjectURL(response.data);
        this.boardForm.legalPersonIdCardBack = imageUrl;
      }).catch(error => {
        console.error('获取法人身份证失败:', error);
        this.$message.error('获取法人身份证失败');
      });
    },

    async downloadFile(customName) {
      try {
        const response = await this.$axios({
          method: 'get',
          url: '/web/template/download/' + customName,
          responseType: 'blob'
        });

        // 优先使用传入的自定义文件名
        let fileName = customName;
        //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
        if (customName.startsWith('AuthorizationLetter')) {
          fileName = "企业身份审核授权书-模版.docx"
        }


        // 处理中文文件名编码问题
        const encodedFileName = encodeURIComponent(fileName);

        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        link.setAttribute('download-filename', encodedFileName); // 兼容性处理
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('文件下载失败: ' + error.message);
      }
    },


    submitForm() {
      this.$refs.boardForm.validate(valid => {
        if (!valid) {
          return false;
        }

        // 校验必传文件
        if (!this.boardForm.businessLicense) {
          this.$message.error('请上传营业执照');
          return false;
        }

        if (!this.boardForm.legalPersonIdCardFront || !this.boardForm.legalPersonIdCardBack) {
          this.$message.error('请上传法人身份证正反面照片');
          return false;
        }

        if (this.boardForm.isLegalPerson === '否' && !this.boardForm.authorizationLetterFlag) {
          this.$message.error('请上传企业身份审核授权书');
          return false;
        }

        if (this.boardForm.isLegalPerson === '否' &&
          (!this.boardForm.agentIdCardFront || !this.boardForm.agentIdCardBack)) {
          this.$message.error('请上传经办人身份证正反面照片');
          return false;
        }

        this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        this.postRequest('/web/companyDetail/add', this.boardForm)
          .then(response => {
            this.$loading().close();
            if (response.status === 200) {
              this.$message.success('认证信息提交成功，请等待审核');
              this.$router.push('/home');
            } else {
              this.$message.error(response.msg || '提交失败');
            }
          })
          .catch(error => {
            this.$loading().close();
            this.$message.error('网络错误，请稍后重试');
            console.error('提交失败:', error);
          });
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error("上传Logo图片只能是 jpg/png 的格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 1MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },

    uploadFile(file) {
      let formData = new FormData();
      formData.append("avatar", file.file);
      //传入其他的参数
      this.postFileRequest("/web/file/uploadAvatar", formData)
        .then((response) => {
          this.boardForm.companyLogo = response.data.object.imageUrl;
        })
        .catch((error) => {
          this.$message.error("上传失败，请稍后重试...");
        });
    },

    async upload_images(options) {
      const { file, onProgress, onSuccess, onError } = options;
      const formData = new FormData();
      formData.append('file', file);

      // 根据上传类型设置不同参数
      let type = '';
      if (options.action === 'legalPersonIdCardFront') {
        type = 'legalPersonIdCardFront';
      } else if (options.action === 'legalPersonIdCardBack') {
        type = 'legalPersonIdCardBack';
      } else if (options.action === 'agentIdCardFront') {
        type = 'agentIdCardFront';
      } else if (options.action === 'agentIdCardBack') {
        type = 'agentIdCardBack';
      } else if (options.action === 'businessLicense') {
        type = 'businessLicense';
      }
      formData.append('type', type);

      this.$axios.post('/web/images/upload', formData, {
        responseType: 'blob'
      }).then(response => {
        const fileUrl = URL.createObjectURL(response.data);
        switch (type) {
          case 'legalPersonIdCardFront':
            this.boardForm.legalPersonIdCardFront = fileUrl;
            break;
          case 'legalPersonIdCardBack':
            this.boardForm.legalPersonIdCardBack = fileUrl;
            break;
          case 'agentIdCardFront':
            this.boardForm.agentIdCardFront = fileUrl;
            break;
          case 'agentIdCardBack':
            this.boardForm.agentIdCardBack = fileUrl;
            break;
          case 'businessLicense':
            this.boardForm.businessLicense = fileUrl;
            break;
          case 'authorizationLetter':
            this.boardForm.authorizationLetter = fileUrl;
            break;
        }
        this.$message.success('文件上传成功');
      }).catch(error => {
        console.error('获取营业执照失败:', error);
        this.$message.error('获取营业执照失败');
      });

    },
    async upload_file(options) {
      const { file, onProgress, onSuccess, onError } = options;
      const formData = new FormData();
      formData.append('file', file);

      // 根据上传类型设置不同参数
      let type = '';
      if (options.action === 'authorizationLetter') {
        type = 'authorizationLetter';
      }


      this.$axios.post('/web/images/fileUpload', formData, {

        responseType: 'blob'

      }).then(response => {
        this.boardForm.authorizationLetter = URL.createObjectURL(response.data);
        this.boardForm.authorizationLetterFlag = "authorizationLetter";
      }).catch(error => {
        console.error('上传企业身份审核授权书成败:', error);
        this.$message.error('上传企业身份审核授权书失败');
      });
      // 更新授权书状态




    },

    beforeFileUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isPDF = file.type === 'application/pdf';
      const isLt10M = file.size / 1024 / 1024 < 100;

      if (!isJPG && !isPNG && !isPDF) {
        this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }
      return true;
    },

    initDetailInfo() {


      let user = JSON.parse(window.localStorage.getItem('user'));
      //console.log("useid:  " + user.id)


      this.getRequest(
        "/web/companyDetail/queryForModify?userId=" + user.id
      ).then((resp) => {
        //console.log(resp.data.socialcreditcode);
        if (resp) {
          this.boardForm = resp.data;

        }

      });


    },

    handleNoCreditCodeChange(val) {
      if (val) {
        this.boardForm.socialCreditCode = "无";
      } else {
        this.boardForm.socialCreditCode = "";
      }
    },
    resetForm() {
      this.$refs.boardForm.resetFields()
    }
  }
}
</script>

<style>
.auth-form-container {
  padding: 0px;
  margin: 0;
  width: 100%;
}

.auth-form-card {
  margin-bottom: 15px;
  border-radius: 10px !important;
  width: 200%;
  margin-left: 0%;
  margin-right: 10%;
}

.item {
  float: left;
  /* 或者 right，取决于你想要哪个元素在左边或右边 */
  width: 50%;
  /* 或者具体的像素值，确保两个div加起来等于父容器的宽度 */
}

.container::after {
  content: "";
  clear: both;
  /* 清除浮动 */
  display: table;
  /* 为了确保清除有效 */
}

.w-e-text-container {
  background-color: white;
  height: 450px !important;
}

.editor {
  margin-top: 40px;
  /*position: relative;
        margin-top: 200px;*/
}

.form-item {
  width: 100%;
  max-width: 500px;
  text-align: left;
}

.board-form {
  margin-top: 20px;
}

.card-body {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0;
}
</style>
<style scoped>
.card-content {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #999;
  padding: 0 20px;
}

.card-num {
  font-size: 30px;
}

.card-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}

.bg1 {
  background: #2d8cf0;
}

.bg2 {
  background: #64d572;
}

.bg3 {
  background: #f25e43;
}

.bg4 {
  background: #e9a745;
}

.color1 {
  color: #2d8cf0;
}

.color2 {
  color: #64d572;
}

.color3 {
  color: #f25e43;
}

.color4 {
  color: #e9a745;
}

.chart {
  width: 100%;
  height: 400px;
}

.card-header {
  padding-left: 10px;
  margin-bottom: 20px;
}

.card-header-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.card-header-desc {
  font-size: 14px;
  color: #999;
}

.timeline-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #000;
}

.timeline-time,
.timeline-desc {
  font-size: 12px;
  color: #787878;
}

.rank-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.rank-item-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f2f2f2;
  text-align: center;
  line-height: 40px;
  margin-right: 10px;
}

.rank-item-content {
  flex: 1;
}

.rank-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #343434;
  margin-bottom: 10px;
}

.rank-item-desc {
  font-size: 14px;
  color: #999;
}

.map-chart {
  width: 100%;
}

.paragraph-style {
  margin-bottom: 6px;
}

.div-style {
  margin-top: 20px;
}

.left-aligned-black-text {
  color: black;
  text-align: left;
  /* 通常text-align默认为left，但明确指定也无妨 */
}

.paragraph-style {
  margin-bottom: 6px;
}

.label-left {
  text-align: left !important;
  /* 使用!important确保覆盖默认样式 */
}

.upload-section {
  margin-bottom: 20px;
}

.upload-area {
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
}

.upload-placeholder {
  color: #8c939d;
  font-size: 14px;
}

.upload-icon {
  font-size: 28px;
  margin-bottom: 10px;
}

.file-preview {
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.file-preview i {
  margin-right: 10px;
  color: #67C23A;
}

.download-links {
  margin-bottom: 15px;
}

.download-link {
  color: #409EFF;
  cursor: pointer;
  margin-right: 15px;
  font-size: 14px;
}

.upload-header1 {
  margin-bottom: 15px;
  font-size: 14px;
  color: #606266;
}

.required-mark {
  color: #f56c6c;
  margin-right: 5px;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>